import * as React from 'react'
import { FC, useState } from 'react'
import './HamburgerMenu.scss'
import { VMTitle } from '../../index'

interface Props {
    menuItems: VMTitle[]
}

const HamburgerMenu: FC<Props> = ({ menuItems }) => {
    const [menuOpen, setMenuOpen] = useState(false)

    return (
        <>
            <div className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen((v) => !v)}>
                <span></span>
                <span></span>
                <span></span>
            </div>

            <nav className={`fullscreen-menu ${menuOpen ? 'show' : ''}`}>
                <h2>
                    FOR YOUR <br />
                    CONSIDERATION
                </h2>
                <h3>Amazon original movies</h3>
                <ul>
                    {menuItems.map((el, index) => (
                        <li key={index}>
                            <a href={el.url}>{el.titleImageMenu && <img src={el.titleImageMenu} alt={el.title} />}</a>
                        </li>
                    ))}
                </ul>
            </nav>
        </>
    )
}

export default HamburgerMenu
